export const NAV = [
  { href: "#services", label: "Treatments" },
  { href: "#prices", label: "Prices" },
  { href: "#about", label: "Our Story" },
  { href: "/our-work", label: "Our Work" },
  { href: "/shop", label: "Shop" },
  { href: "#visit", label: "Visit Us" },
];
